var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.362,
    height: 52.363,
    viewBox: "0 0 52.362 52.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.905 19.567h-.466v-1.4a.466.466 0 00-.466-.466h-1.4V9.318h.466a.466.466 0 00.466-.466v-1.4h1.4a.467.467 0 00.235-.869L10.959.063a.469.469 0 00-.485.009L.224 6.595a.467.467 0 00.251.86h1.4v1.4a.466.466 0 00.466.466H2.8V17.7H1.4a.466.466 0 00-.466.466v1.4H.475a.466.466 0 00-.466.466V21.9a.466.466 0 00.466.466h21.43a.466.466 0 00.466-.466v-1.867a.466.466 0 00-.466-.466zM7.463 17.7H5.6V9.318h1.863zm4.659 0h-1.864V9.318h1.864zm4.659 0h-1.864V9.318h1.863zm.207-11.181l-6.253-3.644L5 6.523H3.267l7.207-4.586a.465.465 0 01.484-.009l7.878 4.6h-1.849z",
    "data-name": "monument icon",
    transform: "translate(14.99 12)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonument);
export default __webpack_public_path__ + "static/media/monument.be2838799f2fcf25e40bbc9d56aeb1cd.svg";
export { ForwardRef as ReactComponent };